import { IRawTimeOccurrenceDatatype } from '../datastore/time/data_types';

export enum TransactionTypeEnum {
  SAVE,
  DELETE,
  EDIT
}

export interface IExternalActionTimeSlot {
  id?: number | string;
  trackingId: string;
  save: IRawTimeOccurrenceDatatype;
}

export interface ITransaction {
  type: TransactionTypeEnum;
  toAdd: IExternalActionTimeSlot[];
  toDelete: IExternalActionTimeSlot[];
}

export interface IExternalActionResponse {
  id: number;
}



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-calendar/src/external_actions/transaction_types.ts